import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputNumber from "@/components/desktop/form/input/input-number/CustomInputNumber";
import CustomDateInput from "@/components/desktop/form/input/input-date/CustomDateInput";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import CustomQuickButton from "../../quickButtons/CustomQuickButton";

const HA_LABEL_REGEX = /^(.+?)\s*•\s*([\d.,]+)\s*Ha$/i;

const buildFormatOptionLabel = (options) => {
	const hasHa = options.some((o) => HA_LABEL_REGEX.test(o.label));
	if (!hasHa) return undefined;

	return (option) => {
		const match = option.label.match(HA_LABEL_REGEX);
		if (!match) return <span>{option.label}</span>;
		const [, name, ha] = match;
		return (
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "0.5rem", width: "100%" }}>
				<div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
					<span
						style={{
							width: 8,
							height: 8,
							borderRadius: "50%",
							flexShrink: 0,
							background: option.color || "#22c55e",
						}}
					/>
					<span style={{ fontWeight: 500 }}>{name.trim()}</span>
				</div>
				<span style={{ fontSize: "0.75rem", color: "#6b7280", whiteSpace: "nowrap" }}>{ha} ha</span>
			</div>
		);
	};
};

const FilterField = ({ styles, filter, onChange }) => {
	const inputId = `f-${filter.key}`;

	return (
		<div className={styles.field}>
			<label htmlFor={inputId} className={styles.label}>
				{filter.label}
			</label>

			{filter.type === "quick" && <CustomQuickButton quickActions={filter.options || []} />}

			{filter.type === "text" && (
				<CustomInputText
					id={inputId}
					value={filter.value ?? ""}
					onChange={(val) => onChange(filter.key, val)}
					placeholder={filter.placeholder || ""}
					size="sm"
				/>
			)}

			{filter.type === "number" && (
				<CustomInputNumber
					id={inputId}
					value={filter.value ?? ""}
					onChange={(val) => onChange(filter.key, val ?? "")}
					placeholder={filter.placeholder || ""}
					size="sm"
				/>
			)}

			{filter.type === "date" && (
				<CustomDateInput
					id={inputId}
					value={filter.value ?? ""}
					onChange={(val) => onChange(filter.key, val)}
					placeholder={filter.placeholder || ""}
					size="sm"
				/>
			)}

			{filter.type === "select" && (
				<CustomInputSelect
					id={inputId}
					options={filter.options || []}
					isMulti={!!filter.multiple}
					value={filter.value ?? ""}
					onChange={(val) => onChange(filter.key, val ?? "")}
					placeholder={filter.placeholder || "Seleccionar"}
					isClearable={!filter.multiple}
					size="sm"
					components={{ NoOptionsMessage }}
					formatOptionLabel={buildFormatOptionLabel(filter.options || [])}
				/>
			)}

			{filter.type === "switch" && <CustomInputSwitch value={!!filter.value} onChange={(val) => onChange(filter.key, val)} />}
		</div>
	);
};

export default FilterField;
